import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { FloatingContact } from '../ui/FloatingContact';
import { useScrollEffects } from '../../hooks/useScrollEffects';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      try {
        window.scrollTo(0, 0);
      } catch {
        // jsdom test environment
      }
    }
  }, [pathname]);

  return null;
}

export function Layout({ children }) {
  const { showBackToTop, scrollToTop } = useScrollEffects();

  return (
    <div className="bg-gradient-purple text-light min-h-screen font-sans flex flex-col">
      <ScrollToTop />
      <Header onNavClick={scrollToTop} />
      <main className="flex-1 page-enter">{children}</main>
      <Footer />
      <FloatingContact />
      <button
        type="button"
        aria-label="返回顶部"
        onClick={scrollToTop}
        className={`fixed bottom-6 right-6 w-12 h-12 rounded-full bg-primary/90 text-white shadow-lg transition-all duration-300 hover:bg-primary z-40 ${
          showBackToTop ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      >
        <i className="fa fa-chevron-up" />
      </button>
    </div>
  );
}
